export interface ArticleCard {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  readingTime: number;
  publishDate: string;
  updatedDate: string;
  imageSeq: string;
  featured: boolean;
}

export const articles: ArticleCard[] = [
  {
    id: 'superbuy-spreadsheet-guide-2026',
    slug: '/superbuy-spreadsheet-guide',
    title: 'The Ultimate Superbuy Spreadsheet Guide 2026: Find the Best Products Fast',
    excerpt: 'Learn how to use a Superbuy spreadsheet to discover trending products, save money on international shipping, and shop like a pro. Our comprehensive guide covers everything from beginner tips to advanced sourcing strategies.',
    category: 'Guides',
    readingTime: 8,
    publishDate: '2026-06-01',
    updatedDate: '2026-06-20',
    imageSeq: 'article-main-sb-v2',
    featured: true,
  },
  {
    id: 'superbuy-safe-shopping',
    slug: '/superbuy-safe-shopping-tips',
    title: 'Is Superbuy Safe? Complete Safety Guide for International Shoppers',
    excerpt: 'Everything you need to know about shopping safely through Superbuy. We cover payment protection, quality inspection, shipping insurance, and how to avoid common scams when using spreadsheets to source products.',
    category: 'Safety',
    readingTime: 6,
    publishDate: '2026-05-20',
    updatedDate: '2026-06-18',
    imageSeq: 'article-safe-sb-v2',
    featured: false,
  },
  {
    id: 'superbuy-qc-guide',
    slug: '/superbuy-qc-inspection-guide',
    title: 'Superbuy QC Guide: How to Inspect Products Before Shipping',
    excerpt: 'Master the art of quality control with your Superbuy spreadsheet. Our step-by-step QC inspection guide helps you identify defects, request better photos, and ensure you receive exactly what you ordered every time.',
    category: 'Guides',
    readingTime: 7,
    publishDate: '2026-05-10',
    updatedDate: '2026-06-15',
    imageSeq: 'article-qc-sb-v2',
    featured: false,
  },
  {
    id: 'superbuy-shipping-guide',
    slug: '/superbuy-shipping-cost-guide',
    title: 'Superbuy Shipping Guide 2026: Save Money on International Delivery',
    excerpt: 'Compare shipping lines, understand weight calculations, and learn packing tricks that can cut your Superbuy shipping costs by up to 40%. Updated with the latest 2026 carrier rates and spreadsheet optimization tips.',
    category: 'Shipping',
    readingTime: 5,
    publishDate: '2026-06-05',
    updatedDate: '2026-06-19',
    imageSeq: 'article-shipping-sb-v2',
    featured: false,
  },
  {
    id: 'superbuy-budget-guide',
    slug: '/superbuy-budget-spreadsheet-guide',
    title: 'Superbuy Budget Spreadsheet: Find the Best Deals Under $50',
    excerpt: 'Discover how to use a budget-focused Superbuy spreadsheet to find quality fashion items at affordable prices. Our guide covers the best budget categories and money-saving strategies.',
    category: 'Guides',
    readingTime: 6,
    publishDate: '2026-06-10',
    updatedDate: '2026-06-19',
    imageSeq: 'article-budget-sb-v2',
    featured: false,
  },
  {
    id: 'superbuy-top-finds',
    slug: '/superbuy-top-finds-june-2026',
    title: 'Top 50 Superbuy Spreadsheet Finds: June 2026 Edition',
    excerpt: 'Our monthly roundup of the hottest Superbuy spreadsheet discoveries. Featured products across all 14 categories with direct links, prices, and seller ratings.',
    category: 'Trending',
    readingTime: 10,
    publishDate: '2026-06-15',
    updatedDate: '2026-06-20',
    imageSeq: 'article-finds-sb-v2',
    featured: false,
  },
  {
    id: 'superbuy-haul-review',
    slug: '/superbuy-haul-review-guide',
    title: 'Superbuy Haul Review: What I Actually Received vs. Spreadsheet Photos',
    excerpt: 'An honest review of products ordered from the Superbuy spreadsheet. See real photos of what arrived, compare with listing images, and learn which categories deliver the best results.',
    category: 'Reviews',
    readingTime: 7,
    publishDate: '2026-06-12',
    updatedDate: '2026-06-18',
    imageSeq: 'article-haul-sb-v2',
    featured: false,
  },
  {
    id: 'superbuy-sneaker-guide',
    slug: '/superbuy-best-sneaker-spreadsheet',
    title: 'The Best Superbuy Sneaker Spreadsheet: Complete Sneakerhead Guide 2026',
    excerpt: 'Everything sneakerheads need to know about using Superbuy spreadsheets for finding rare and trending sneakers. Includes size conversion tips, seller verification, and QC checklist.',
    category: 'Guides',
    readingTime: 9,
    publishDate: '2026-06-08',
    updatedDate: '2026-06-20',
    imageSeq: 'article-sneaker-sb-v2',
    featured: false,
  },
  {
    id: 'superbuy-streetwear-guide',
    slug: '/superbuy-streetwear-spreadsheet',
    title: 'Superbuy Streetwear Spreadsheet: Hoodies, Tees & Essentials Guide',
    excerpt: 'Your complete guide to the streetwear section of the Superbuy spreadsheet. Discover the best hoodie sellers, t-shirt factories, and how to build a killer streetwear wardrobe on a budget.',
    category: 'Guides',
    readingTime: 7,
    publishDate: '2026-06-05',
    updatedDate: '2026-06-19',
    imageSeq: 'article-street-sb-v2',
    featured: false,
  },
  {
    id: 'superbuy-size-guide',
    slug: '/superbuy-size-conversion-guide',
    title: 'Superbuy Size Conversion Guide: Never Order the Wrong Size Again',
    excerpt: 'Master international sizing when using the Superbuy spreadsheet. Complete conversion charts for shoes, clothing, and accessories across US, EU, UK, and Asian size systems.',
    category: 'Guides',
    readingTime: 5,
    publishDate: '2026-06-03',
    updatedDate: '2026-06-17',
    imageSeq: 'article-size-sb-v2',
    featured: false,
  },
  {
    id: 'superbuy-seller-guide',
    slug: '/superbuy-seller-verification-guide',
    title: 'Superbuy Seller Verification: How to Spot Trustworthy Spreadsheet Sellers',
    excerpt: 'Learn how to verify seller quality before purchasing from a Superbuy spreadsheet. Our system for evaluating ratings, reviews, and red flags to ensure safe shopping every time.',
    category: 'Safety',
    readingTime: 6,
    publishDate: '2026-05-28',
    updatedDate: '2026-06-16',
    imageSeq: 'article-seller-sb-v2',
    featured: false,
  },
  {
    id: 'superbuy-custom-guide',
    slug: '/superbuy-custom-order-guide',
    title: 'Superbuy Custom Orders: Using Spreadsheets for Bespoke Fashion Items',
    excerpt: 'Discover how to use Superbuy spreadsheets to order custom-sized clothing and personalized items. From tailored jackets to monogrammed accessories, get exactly what you want.',
    category: 'Guides',
    readingTime: 7,
    publishDate: '2026-05-25',
    updatedDate: '2026-06-14',
    imageSeq: 'article-custom-sb-v2',
    featured: false,
  },
  {
    id: 'superbuy-agent-guide',
    slug: '/superbuy-agent-comparison-guide',
    title: 'Superbuy vs Other Agents: Why Our Spreadsheet Works Best with Superbuy',
    excerpt: 'Comparing shopping agents for spreadsheet-based purchasing. Why Superbuy offers the best QC, shipping options, and user experience for spreadsheet shoppers in 2026.',
    category: 'Comparisons',
    readingTime: 6,
    publishDate: '2026-05-20',
    updatedDate: '2026-06-13',
    imageSeq: 'article-agent-sb-v2',
    featured: false,
  },
];